import { render } from "./leaderboard-month-filter.vue?vue&type=template&id=00971c3c&scoped=true&ts=true"
import script from "./leaderboard-month-filter.vue?vue&type=script&lang=ts"
export * from "./leaderboard-month-filter.vue?vue&type=script&lang=ts"

import "./leaderboard-month-filter.vue?vue&type=style&index=0&id=00971c3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00971c3c"]])

export default __exports__